<template>
    <div class="bg-light py-3">
        <div class="container">
            <nav
                style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.5 11L1.5 6L6.5 1' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E&#34;);"
                aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 small">
                    <li class="breadcrumb-item"><a href="/">خانه</a></li>
                    <li v-for="link in links" class="breadcrumb-item" :class="{active: !link.url}">
                        <Link v-if="link.url" :href="link.url">{{ link.title }}</Link>
                        <template v-else>{{link.title}}</template>
                    </li>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/inertia-vue3";

export default {
    components: {
        Link,
    },
    props: {
        links: {
            default: [],
        }
    },
}
</script>

<style scoped>

</style>
